import React from 'react';
import { Link } from 'react-router-dom';
import "./Footer.css";

const Footer = () => {
  return (
    <div className='footer bg-dark section-p' id="footer">
      <div className='container'>
        <div className='section-title'>
          <h3 className='text-brown'>Invierte con <span className='text-white'>Nosotros</span></h3>
        </div>
        <div className='footer-content'>
          <p className='text-center fs-14 text-white op-07 fw-3 ls-1'>
            <Link to="/terms" className='text-white'>Términos de Servicio</Link>
          </p>
          <p className='text-center fs-14 text-white op-07 fw-3 ls-1'>
            <Link to="/policy" className='text-white'>Política de Privacidad</Link>
          </p>
          <p className='text-center fs-14 text-white op-07 fw-3 ls-1 reserved-text'>Calle Lisboa 29, 28850, Madrid. Todos los Derechos Reservados &copy; 2023</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
